﻿﻿import { RemissionStatus } from '../enums/index';

export interface IKidneyStoneRejection {
    id: number;
    remissionStatus: RemissionStatus;
}
